// extracted by mini-css-extract-plugin
export default {"ctn":"Region_ctn__y2zI8","wrp":"Region_wrp__QIzGI"};